import React from "react";
import HumanLogo from "../../img/human-logo.svg";
import FuelPromo from "../../img/fuel-promo.svg";
import DotLogo from "../../img/dot-logo.svg";
import { useStore } from "../../store";

import {
  PreviewStyles,
  BodyStyles,
  HeaderStyle,
  HumanLogoStyles,
  FuelPromoLogoStyles,
} from "./PromoPart.styles";
import i18nStrings from "../../strings/stings";
import { roles } from "../../const";

const PromoPart = () => {
  const strings = i18nStrings;
  const { globalModule } = useStore();
  const { role } = globalModule;

  const getListItems = () => {
    if (role === roles.carrier) {
      return (
        <div className="pay-list-style">
          <HeaderStyle>{strings.titleForCarrier}</HeaderStyle>
          <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.payment}</li></div>
          <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.limit}</li></div>
          <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.onePersent}</li></div>
          <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.payWhen}</li></div>
        </div>
        );
    }

    if (role === roles.topShipper) {
      return (
        <div className="pay-list-style">
          <HeaderStyle>{strings.titleForShipper}</HeaderStyle>
          <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.youHaveMoney}</li></div>
          <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.individualLimit}</li></div>
          <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.useMoney}</li></div>
          <ul className="under-point">
            <li>{strings.repayment}</li>
            <li>{strings.repair}</li>
            <li>{strings.salary}</li>
          </ul>
        </div>
      );
    }

    if (role === roles.fuel) {
      return (
        <div className="pay-list-style">
          <HeaderStyle>{strings.titleForFuel}</HeaderStyle>
          <div>{strings.fuelPromoDescription}</div>
          <br />
          <ul className="under-point">
            <li>{strings.workWithoutInterruption}</li>
            <li>{strings.freeMoneyAlwaysAtHand}</li>
            <li>{strings.saveUp}</li>
          </ul>
        </div>
      );
    }

    return (
      <div className="pay-list-style">
        <HeaderStyle>{strings.titleForShipper}</HeaderStyle>
        <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.youHaveMoney}</li></div>
        <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.limit}</li></div>
        <div className="point"><img alt="" className="img" src={DotLogo} /><li className="list">{strings.useMoney}</li></div>
        <ul className="under-point">
          <li>{strings.repayment}</li>
          <li>{strings.repair}</li>
          <li>{strings.salary}</li>
        </ul>
      </div>
    );
  };

  const renderLogo = () => {
    if (role === roles.fuel) return <FuelPromoLogoStyles alt="" src={FuelPromo} />;
    return <HumanLogoStyles alt="" src={HumanLogo} />;
  };

  return (
    <PreviewStyles className={role === roles.carrier ? "carrier" : "shipper"}>
      <div className={role === roles.carrier ? "carrier" : "shipper"}>
        <BodyStyles>
          <div className="logo-contaiter">
            {renderLogo()}
          </div>
          {getListItems()}
        </BodyStyles>
      </div>
    </PreviewStyles>
  );
};

export default PromoPart;
